import styled from "styled-components";
import { colors } from "../../../constants/colors";

export const StyledWithIconButton = styled.button`
  background-color: white;
  display: flex;
  align-items: center;

  width: fit-content;
  height: fit-content;
  border: 1px solid;
  border-color: ${colors.lightGray};
  border-radius: 50px;
  padding: 0.2rem 0.8rem;
  white-space: nowrap;

  font-size: 0.7rem;
  color: ${colors.text};

  cursor: pointer;
  :hover {
    opacity: 0.8;
  }

  > * {
    width: 1.5em;
    margin-right: 0.5rem;
  }
`;
